import { FC, Fragment, useId } from 'react';

export interface Props {
   text: string;
   searchValue?: string;
}

const removeDiacritics = (str: string) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const HighlightText: FC<Props> = ({ text, searchValue }) => {
   const id = useId();
   const trimmedText = removeDiacritics(text.trim());
   const trimmedHighlightedTerms = searchValue?.trim();

   if (!trimmedText || !trimmedHighlightedTerms) return text;

   const escapedTerms = trimmedHighlightedTerms.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
   const sortedHighlightedTerms = removeDiacritics(escapedTerms)
      .split(' ')
      .sort((a, b) => b.length - a.length);
   const highlightRegex = new RegExp(`(${sortedHighlightedTerms.join('|')})`, 'gi');

   return removeDiacritics(text)
      .split(highlightRegex)
      .reduce<
         Array<{
            index: number;
            diacriticslessPart: string;
            correspondingOriginalPart: string;
         }>
      >((acc, diacriticslessPart) => {
         const previousItem = acc[acc.length - 1];
         const previousSplitIndex = !previousItem ? 0 : previousItem.index + previousItem.diacriticslessPart.length;
         const nextSplitIndex = previousSplitIndex + diacriticslessPart.length;
         const correspondingOriginalPart = text.substring(previousSplitIndex, nextSplitIndex);
         acc.push({ index: previousSplitIndex, diacriticslessPart, correspondingOriginalPart });
         return acc;
      }, [])
      .map(({ diacriticslessPart, correspondingOriginalPart }, index) => (
         // eslint-disable-next-line @eslint-react/no-array-index-key
         <Fragment key={`${id}-${index}`}>{highlightRegex.test(diacriticslessPart) ? <b>{correspondingOriginalPart}</b> : correspondingOriginalPart}</Fragment>
      ));
};
